import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'dbm-master-detail-list',
    template: require('./dbm-master-detail-list.component.html'),
    styles: [require('./dbm-master-detail-list.component.scss')]
})
export class DbmMasterDetailListComponent {
    @Input() public listTitle: string;
    @Input() public listAction: string;
    @Input() public masterListTitle: string;
    @Input() public masterListApplyRemove: boolean;
    @Input() public masterListItems: any[];
    @Input() public detailListTitle: string;
    @Input() public detailListSearchPlaceholder: string;
    @Input() public detailListItems: any[];
    @Input() public withEdit: boolean;

    @Output() public onListAction = new EventEmitter();
    @Output() public onSelectMaster = new EventEmitter<any>();
    @Output() public onDetailsListChanged = new EventEmitter();
    @Output() public onListItemRemove = new EventEmitter<any>();
    @Output() public onSave = new EventEmitter();
    @Output() public onCancel = new EventEmitter();

    public filter = '';
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-master-detail-list/dbm-master-detail-list.component.ts